/* The BFF reports its error codes inside the GraphQL error message rather than
/* in `extensions` - `CustomerAccountServiceException : AUTH_ERR_105`. An
/* AuthenticationException raised by the `@StateValidation` aspect is wrapped in
/* an UndeclaredThrowableException before the DGS exception handler ever sees it,
/* and by then the code survives only as text in that message. Matching the code
/* rather than the wrapper means renaming the exception cannot break this - the
/* same approach @thd-olt-component-react/military-verification takes to read the
/* MD_ERR_0xx codes off a failed verification.
/*
/* This is what replaced the HTTP statuses the REST enrollment call was read by:
/* a GraphQL request resolves 200 whatever the resolver did, so there is no 401
/* or 403 left to branch on. */
const AUTH_ERROR_CODE = /AUTH_ERR_\d+/;

/* The two codes that mean the session itself is the problem, and the reason this
/* is a list rather than an `AUTH_ERR_` prefix test: a permissions refusal
/* (AUTH_ERR_102, USER_NOT_PERMITTED) is also an AUTH_ERR_, and a customer who is
/* signed in but not allowed would be sent to sign in only to come back to the
/* same refusal. */
const SESSION_ERROR_CODES = new Set([
  'AUTH_ERR_101', // MISSING_USER_TOKEN
  'AUTH_ERR_105', // USER_NOT_AUTHORIZED
]);

export const readAuthErrorCode = (message) =>
  message?.match(AUTH_ERROR_CODE)?.[0] ?? null;

/* Whether a failed query means "sign in again".
/*
/* Takes the ApolloError the query hands back rather than a list, because where
/* the errors live is part of the question: `graphQLErrors` is where a resolver's
/* own failures land, and a request that never reached the resolver has none at
/* all - a network failure is not a session problem and must not be read as one. */
export const isAuthFailure = (error) =>
  !!error?.graphQLErrors?.some((graphQLError) =>
    SESSION_ERROR_CODES.has(readAuthErrorCode(graphQLError?.message)),
  );
